// config.ts
import { Config } from "@adornis/config/config.js";
var accountingConfig = new Config("accounting-config", {
  ACCOUNTING_LETTER_SENDER: {
    env: true,
    client: true,
    required: false,
    defaultVal: "Muster GmbH | Stra\xDFe | PLZ Stadt",
    name: "ACCOUNTING_LETTER_SENDER"
  },
  DATEV_BERATERNUMMER: {
    env: true,
    client: false,
    required: true,
    name: "DATEV_BERATERNUMMER"
  },
  DATEV_MANDANTENNUMMER: {
    env: true,
    client: false,
    required: true,
    name: "DATEV_MANDANTENNUMMER"
  },
  DISABLE_PRINT: {
    env: true,
    client: false,
    required: false,
    defaultVal: false,
    name: "DISABLE_PRINT"
  },
  ACCOUNTING_PRINT_TIMEOUT: {
    env: true,
    client: false,
    required: false,
    defaultVal: 5e3,
    name: "ACCOUNTING_PRINT_TIMEOUT"
  }
});
export {
  accountingConfig
};
